import React from "react";
import { Link } from "react-router-dom";
import { DogIcon as Dog } from "@phosphor-icons/react";
import { photoUrl } from "@/lib/utils-app";

export default function ParentLink({ label, dog }) {
  return (
    <div className="border border-[#E5E5E5] rounded-lg p-4">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#6B6B6B] mb-2">{label}</div>
      {dog ? (
        <Link to={`/dogs/${dog.id}`} className="flex items-center gap-3 hover:underline">
          <div className="h-10 w-10 rounded-md overflow-hidden bg-[#FAFAFA]">
            {dog.photos?.[0] ? (
              <img src={photoUrl(dog.photos[0])} alt={dog.name} className="h-full w-full object-cover" />
            ) : (
              <div className="h-full w-full flex items-center justify-center">
                <Dog size={18} className="text-[#6B6B6B]/40" />
              </div>
            )}
          </div>
          <div>
            <div className="font-medium">{dog.name}</div>
            <div className="text-xs text-[#6B6B6B]">{dog.breed}</div>
          </div>
        </Link>
      ) : (
        <div className="text-sm text-[#6B6B6B]">Unknown</div>
      )}
    </div>
  );
}
